"use client";
import Script from "next/script";
import { useMatchMedia } from "@jetblue/kit/hooks/use-match-media";
import React from "react";

type QualtricsInjectorProperties = {
  readonly interceptId: string;
  readonly src: string;
};

const DOTCOM_MD_BREAKPOINT = "48em";

function subscribe(_callback: () => void) {
  return _callback;
}
const getClientSnapshot = () => true;
const getServerSnapshot = () => false;

export function QualtricsInjector({
  interceptId,
  src,
}: QualtricsInjectorProperties) {
  const isClient = React.useSyncExternalStore(
    subscribe,
    getClientSnapshot,
    getServerSnapshot,
  );
  const isMobile = useMatchMedia(`(max-width: ${DOTCOM_MD_BREAKPOINT})`);

  if (!isClient || isMobile || !src || !interceptId) {
    return null;
  }

  return (
    <>
      <Script src={src} />
      <aside aria-label="Survey" id={interceptId}></aside>
    </>
  );
}
